import styled from "styled-components";

const Container = styled.button`
	width: 104px;
	height: 32px;
	background: ${(props) => (props.isPrincipal ? "#3366ff" : "white")};
	border-radius: 4px;
	color: ${(props) => (props.isPrincipal ? "white" : "#3366ff")};
	border: ${(props) => (props.isPrincipal ? "none" : "#3366ff 1px solid")};
	font-size: 14px;
`;
const Disbaled = styled.button`
	width: 104px;
	height: 32px;
	background: #F5F5F5;
	border-radius: 4px;
	color: rgba(0, 0, 0, 0.25);
	border: none;
	font-size: 14px;
`;

const Button = ({ text, isPrincipal, onClick, disabled = false }) => {
    if (disabled) {
        return (
            <Disbaled >
                {text}
            </Disbaled>
        )
    }
    return (
        <Container onClick={(e) => {
            e.preventDefault();
            onClick()
        }} isPrincipal={isPrincipal}>
            {text}
        </Container>
    );
};

export default Button;
